module.exports = __webpack_public_path__ + "static/media/sociali.2acb1a02.svg";